export default class API_URLs {
  static API_URL = `https://api.amir-dadkhah.ir`;
}
